import { TFunction } from 'i18next'

import { ApiError } from '../state/api'

type UseSetFormErrorsParams = {
  t: TFunction
}

export default function getErrorMesssage({ t }: UseSetFormErrorsParams, err: any) {
  if (err instanceof ApiError) {
    if (err.fields) {
      const messages: string[] = []
      for (const [rawKey, rawMessages] of Object.entries(err.fields)) {
        const key = rawKey
          .split('.')
          .map((s) => s.replaceAll(/_[a-z]/g, (r) => r[1].toUpperCase()))
          .join('.')
        const message = (rawMessages[0] || 'invalid').replaceAll('.', '-')
        messages.push(t([`errors.fields.${key}.${message}`, `errors.fields.default.${message}`]))
      }
      return messages.join(', ')
    } else {
      const text = t(`errors.${err.message.replaceAll('.', '-')}`)
      return text === `errors.${err.message.replaceAll('.', '-')}` ? err.message : text
    }
  } else {
    return String(err)
  }
}
